window.__ONEMATE_STORES__ = [
  {
    "name": "Streck",
    "address": "Straubinger Straße 42",
    "city": "Abensberg",
    "zip": "93326",
    "country": "DE",
    "phone": "0 94 43 / 99 22 554",
    "website": "",
    "lat": 48.8100982,
    "lng": 11.8590953,
    "tags": [],
    "note": ""
  },
  {
    "name": "Abegg GmbH",
    "address": "Osterstraße 4",
    "city": "Aurich",
    "zip": "26603",
    "country": "DE",
    "phone": "04941 2595",
    "website": "",
    "lat": 53.4690922,
    "lng": 7.4830982,
    "tags": [],
    "note": ""
  },
  {
    "name": "LEDER-STYLE-ACCESSOIRES",
    "address": "Weinstr. Süd 7",
    "city": "Bad Dürkheim",
    "zip": "67098",
    "country": "DE",
    "phone": "+49 6322 9489922",
    "website": "http://www.leder-style-accessoires.de",
    "lat": 49.4599102,
    "lng": 8.1682569,
    "tags": [],
    "note": ""
  },
  {
    "name": "Ranzenfee & Koffertroll GmbH",
    "address": "Oudenarder Str. 16",
    "city": "Berlin",
    "zip": "13347",
    "country": "DE",
    "phone": "030 43727165",
    "website": "http://ranzenfee-koffertroll.de",
    "lat": 52.5527395,
    "lng": 13.3606345,
    "tags": [],
    "note": ""
  },
  {
    "name": "Das Ranzen-Kontor",
    "address": "Georgenstraße 24",
    "city": "Berlin",
    "zip": "10117",
    "country": "DE",
    "phone": "",
    "website": "https://ranzenkontor.de/",
    "lat": 52.5196341,
    "lng": 13.3868097,
    "tags": [
      "premium"
    ],
    "note": ""
  },
  {
    "name": "Ferdinand Weiss Bürobedarfshaus OHG",
    "address": "Sack 21-22",
    "city": "Braunschweig",
    "zip": "38100",
    "country": "DE",
    "phone": "0531-125946",
    "website": "",
    "lat": 52.2642215,
    "lng": 10.5216885,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Kohlmarkt 17",
    "city": "Braunschweig",
    "zip": "38100",
    "country": "DE",
    "phone": "0531 45101",
    "website": "",
    "lat": 52.2627875,
    "lng": 10.519622,
    "tags": [],
    "note": ""
  },
  {
    "name": "Lederwaren Radfelder",
    "address": "Grashoffstraße 13",
    "city": "Bremerhaven",
    "zip": "27570",
    "country": "DE",
    "phone": "0471 31074",
    "website": "",
    "lat": 53.5322241,
    "lng": 8.5924438,
    "tags": [],
    "note": ""
  },
  {
    "name": "Schaupp Lederwaren",
    "address": "Josef Meyer Str. 94",
    "city": "Burladingen",
    "zip": "72393",
    "country": "DE",
    "phone": "07475451832",
    "website": "http://www.schaupp-lederwaren.de",
    "lat": 48.3144446,
    "lng": 9.1316398,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Maurer",
    "address": "Sindelfinger Straße 10",
    "city": "Böblingen",
    "zip": "71032",
    "country": "DE",
    "phone": "07031 25790",
    "website": "",
    "lat": 48.6862383,
    "lng": 9.013963,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Strudthoff",
    "address": "Lange Str. 124",
    "city": "Delmenhorst",
    "zip": "27749",
    "country": "DE",
    "phone": "04221 96310",
    "website": "",
    "lat": 53.0500325,
    "lng": 8.6272568,
    "tags": [],
    "note": ""
  },
  {
    "name": "Ranzenfee & Koffertroll GmbH",
    "address": "Wiesenstraße 70",
    "city": "Düsseldorf",
    "zip": "40549",
    "country": "DE",
    "phone": "0211 56948784",
    "website": "http://www.ranzenfee-koffertroll.de",
    "lat": 51.2272504,
    "lng": 6.7064391,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Anger 1",
    "city": "Erfurt",
    "zip": "99084",
    "country": "DE",
    "phone": "0361 6012377",
    "website": "",
    "lat": 50.9776985,
    "lng": 11.0364678,
    "tags": [],
    "note": ""
  },
  {
    "name": "Friedrich Viehausen GmbH",
    "address": "Kölner Straße 16A+B",
    "city": "Erkelenz",
    "zip": "41812",
    "country": "DE",
    "phone": "02431-96690",
    "website": "",
    "lat": 51.0613423,
    "lng": 6.3573272,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Heinz",
    "address": "Europa-Allee 6",
    "city": "Frankfurt",
    "zip": "60327",
    "country": "DE",
    "phone": "",
    "website": "",
    "lat": 50.1093837,
    "lng": 8.6527252,
    "tags": [],
    "note": ""
  },
  {
    "name": "Freiburger Leder Haus",
    "address": "Rathausgasse 4 (in der Bursengalerie)",
    "city": "Freiburg",
    "zip": "79098",
    "country": "DE",
    "phone": "0761 31201",
    "website": "",
    "lat": 47.9956693,
    "lng": 7.8497931,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Droste",
    "address": "Hochstr. 27",
    "city": "Gelsenkirchen Buer",
    "zip": "45894",
    "country": "DE",
    "phone": "0209 3597910",
    "website": "",
    "lat": 51.579585,
    "lng": 7.0530286,
    "tags": [],
    "note": ""
  },
  {
    "name": "Löwengold",
    "address": "Emil-Kemmer-Straße 11",
    "city": "Hallstadt",
    "zip": "96103",
    "country": "DE",
    "phone": "0951 51919710",
    "website": "",
    "lat": 49.9163626,
    "lng": 10.8688903,
    "tags": [
      "premium"
    ],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Julius-Brecht-Strasse 6 (Elbe EKZ)",
    "city": "Hamburg",
    "zip": "22609",
    "country": "DE",
    "phone": "040 80050335",
    "website": "",
    "lat": 53.5701893,
    "lng": 9.8645291,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Hamburger Strasse 27",
    "city": "Hamburg",
    "zip": "22083",
    "country": "DE",
    "phone": "040 22694665",
    "website": "",
    "lat": 53.5734556,
    "lng": 10.0316823,
    "tags": [],
    "note": ""
  },
  {
    "name": "Otto F.K. Koch",
    "address": "Eppendorfer Landstr. 104",
    "city": "Hamburg",
    "zip": "20249",
    "country": "DE",
    "phone": "040-4809210",
    "website": "",
    "lat": 53.5922032,
    "lng": 9.9889698,
    "tags": [],
    "note": ""
  },
  {
    "name": "Koffer Koch",
    "address": "Hoher Weg 9",
    "city": "Hildesheim",
    "zip": "31134",
    "country": "DE",
    "phone": "05121 13520",
    "website": "",
    "lat": 52.1519887,
    "lng": 9.9512184,
    "tags": [],
    "note": ""
  },
  {
    "name": "Lederhaus & Pferdesport Neumeister",
    "address": "Oberes Tor 1",
    "city": "Hof",
    "zip": "95028",
    "country": "DE",
    "phone": "09281 71420",
    "website": "",
    "lat": 50.3192901,
    "lng": 11.9167516,
    "tags": [],
    "note": ""
  },
  {
    "name": "Lederwaren Voegels",
    "address": "Ludwigstr. 1",
    "city": "Köln",
    "zip": "50667",
    "country": "DE",
    "phone": "0221 2577382",
    "website": "https://www.lederwaren-voegels.de/",
    "lat": 50.9372085,
    "lng": 6.9547134,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Marktplatz 11 (Leine Center)",
    "city": "Laatzen",
    "zip": "30880",
    "country": "DE",
    "phone": "0511 2288078",
    "website": "",
    "lat": 52.3076249,
    "lng": 9.8132654,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck",
    "address": "Altstadt 367",
    "city": "Landshut",
    "zip": "84028",
    "country": "DE",
    "phone": "0 871 / 22 44 6",
    "website": "",
    "lat": 48.5377374,
    "lng": 12.1526659,
    "tags": [],
    "note": ""
  },
  {
    "name": "Enno Hinrichs",
    "address": "Mühlenstr. 85",
    "city": "Leer",
    "zip": "26789",
    "country": "DE",
    "phone": "0491 928040",
    "website": "",
    "lat": 53.2304649,
    "lng": 7.4580697,
    "tags": [],
    "note": ""
  },
  {
    "name": "Le Sac",
    "address": "Grabenstraße 53",
    "city": "Limburg an der Lahn",
    "zip": "65549",
    "country": "DE",
    "phone": "06431 22483",
    "website": "",
    "lat": 50.3873625,
    "lng": 8.0639456,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Ernst-Reuter-Allee 11 (Allee Center)",
    "city": "Magdeburg",
    "zip": "39114",
    "country": "DE",
    "phone": "0391 56390990",
    "website": "",
    "lat": 52.1299842,
    "lng": 11.6375371,
    "tags": [],
    "note": ""
  },
  {
    "name": "Ranzenfee & Koffertroll Münsterland GmbH",
    "address": "Schiffahrter Damm 24",
    "city": "Münster",
    "zip": "48145",
    "country": "DE",
    "phone": "0251 39586715",
    "website": "",
    "lat": 51.9681707,
    "lng": 7.656831,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Heinz",
    "address": "Hermesstr. 4",
    "city": "Neu-Isenburg",
    "zip": "63263",
    "country": "DE",
    "phone": "",
    "website": "",
    "lat": 50.0499616,
    "lng": 8.6994738,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck",
    "address": "Johannesstraße 1",
    "city": "Neumarkt-Sankt Veit",
    "zip": "84494",
    "country": "DE",
    "phone": "0 86 39 / 70 87 46",
    "website": "",
    "lat": 48.3603195,
    "lng": 12.5096302,
    "tags": [],
    "note": ""
  },
  {
    "name": "Rund ums Büro Rogge",
    "address": "Glambecker Str. 37",
    "city": "Neustrelitz",
    "zip": "17235",
    "country": "DE",
    "phone": "03981 205022",
    "website": "",
    "lat": 53.3641643,
    "lng": 13.0642091,
    "tags": [],
    "note": ""
  },
  {
    "name": "Holert Lederwaren GmbH",
    "address": "Haarenstraße 51",
    "city": "Oldenburg",
    "zip": "26122",
    "country": "DE",
    "phone": "0441 12675",
    "website": "",
    "lat": 53.1406017,
    "lng": 8.2111756,
    "tags": [],
    "note": ""
  },
  {
    "name": "bimarkt",
    "address": "Hannoversche Str. 82",
    "city": "Osnabrück",
    "zip": "49084",
    "country": "DE",
    "phone": "0541 582020",
    "website": "",
    "lat": 52.2584723,
    "lng": 8.0827693,
    "tags": [],
    "note": ""
  },
  {
    "name": "Ranzenworld",
    "address": "Mannheimer Str. 17",
    "city": "Pforzheim",
    "zip": "75179",
    "country": "DE",
    "phone": "07231 5864540",
    "website": "",
    "lat": 48.9040625,
    "lng": 8.658483,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck",
    "address": "Weichser Weg 5",
    "city": "Regensburg",
    "zip": "93059",
    "country": "DE",
    "phone": "0941 / 640 90 870",
    "website": "",
    "lat": 49.0270178,
    "lng": 12.1151074,
    "tags": [],
    "note": ""
  },
  {
    "name": "Ranzenfee & Koffertroll GmbH",
    "address": "Freigerichtstraße 10",
    "city": "Rheda-Wiedenbrück",
    "zip": "33378",
    "country": "DE",
    "phone": "05242 4044640",
    "website": "http://www.ranzenfee-koffertroll.de",
    "lat": 51.8405684,
    "lng": 8.2968262,
    "tags": [],
    "note": ""
  },
  {
    "name": "Hußmann GmbH",
    "address": "Rheinstr. 17",
    "city": "Rheinberg",
    "zip": "47495",
    "country": "DE",
    "phone": "02843 2153",
    "website": "",
    "lat": 51.5464398,
    "lng": 6.6019812,
    "tags": [],
    "note": ""
  },
  {
    "name": "Lederwaren Krön e. K.",
    "address": "Hauptstr. 17 / 19",
    "city": "Schramberg",
    "zip": "78713",
    "country": "DE",
    "phone": "07422 20835",
    "website": "",
    "lat": 48.2245554,
    "lng": 8.3843692,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck Lederwaren (ab 1.3.)",
    "address": "Friedrich-Ebert-Straße 15",
    "city": "Schwandorf",
    "zip": "92421",
    "country": "DE",
    "phone": "",
    "website": "",
    "lat": 49.3286097,
    "lng": 12.1081139,
    "tags": [],
    "note": ""
  },
  {
    "name": "Talblick-Papier GmbH",
    "address": "Talblick 15",
    "city": "Solingen (Wald)",
    "zip": "42719",
    "country": "DE",
    "phone": "0212 314092",
    "website": "",
    "lat": 51.1865783,
    "lng": 7.028687,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck",
    "address": "Werner-von-Siemens-Straße 2",
    "city": "Traunreut",
    "zip": "83301",
    "country": "DE",
    "phone": "0 86 69 / 78 73 40",
    "website": "",
    "lat": 47.9663135,
    "lng": 12.5863653,
    "tags": [],
    "note": ""
  },
  {
    "name": "Streck",
    "address": "Graslitzer Straße 2",
    "city": "Waldkraiburg",
    "zip": "84478",
    "country": "DE",
    "phone": "0 86 38 / 88 99 60",
    "website": "",
    "lat": 48.2055515,
    "lng": 12.4004356,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Heinz",
    "address": "Gutenbergstr. 5",
    "city": "Weiterstadt",
    "zip": "64331",
    "country": "DE",
    "phone": "",
    "website": "",
    "lat": 49.8921161,
    "lng": 8.6066495,
    "tags": [],
    "note": ""
  },
  {
    "name": "Möbel- und Kinderstudio Riemenschneider",
    "address": "Bahnhofstr. 19-21",
    "city": "Wiesbaden",
    "zip": "65185",
    "country": "DE",
    "phone": "0611 377528",
    "website": "",
    "lat": 50.0783225,
    "lng": 8.2421961,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder-Tausend GmbH",
    "address": "Untermarkt 16",
    "city": "Wolfratshausen",
    "zip": "82515",
    "country": "DE",
    "phone": "08171 16150",
    "website": "http://www.ledertausend.de",
    "lat": 47.9152537,
    "lng": 11.4191211,
    "tags": [],
    "note": ""
  },
  {
    "name": "Jens Koch",
    "address": "Porschestraße 45",
    "city": "Wolfsburg",
    "zip": "38440",
    "country": "DE",
    "phone": "05361 864477",
    "website": "",
    "lat": 52.422283,
    "lng": 10.7886292,
    "tags": [],
    "note": ""
  },
  {
    "name": "Leder Heinz",
    "address": "Am Römischen Kaiser 9",
    "city": "Worms",
    "zip": "67547",
    "country": "DE",
    "phone": "",
    "website": "",
    "lat": 49.6325702,
    "lng": 8.3637805,
    "tags": [],
    "note": ""
  }
];
